<template>
  <div class="image-modal" v-show="modalShown" @click="close()">
    <div class="image-box">
      <img class="sketch-uploade-img" :src="getImage(image)">
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'

export default {
  name: 'SketchUplodeImgView',
  data () {
    return {
      modalShown: false,
      image: ''
    }
  },
  watch: {
  },
  methods: {
    showModal: function (image) {
      this.image = image
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getContentsSkupResource(image)
    }
  }
}
</script>
<style lang="scss" scoped>
.image-modal, .image-box{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.image-modal{
  background-color: rgba(0, 0, 0, .2);
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.sketch-uploade-img{
  width: 500px;
  height: 500px;
}
.close-btn{
  margin-top: 20px;
  background-color: white;
  padding: 5px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/SketchUplodeImgView.vue